export default {
  eyebrow: 'Partnerportal',
  title: 'Abrechnung',
  description:
    'Ihre Zahlungsmethode für die monatliche Plattformrechnung sowie jede Rechnung mit vollständiger Aufschlüsselung.',
  toasts: {
    checkout_error: 'Der Checkout konnte nicht gestartet werden — bitte erneut versuchen.',
    action_error: 'Die Aktion ist fehlgeschlagen — bitte erneut versuchen.',
    onboarding_error: 'Die Verifizierung konnte nicht gestartet werden — bitte erneut versuchen.',
    payment_method_in_use:
      'Die Lizenzen Ihrer Restaurants werden über diese Zahlungsmethode abgerechnet, daher kann sie nicht entfernt werden. Ersetzen Sie sie stattdessen durch eine neue.',
  },
  payout_bank_account: {
    title: 'Bankkonto für Auszahlungen',
    description:
      'Auszahlungen der Umsatzbeteiligung kommen in {{currency}} an. Stripe rechnet die Überweisung bei Eingang um.',
    toasts: {
      saved: 'Bankkonto gespeichert',
      save_failed: 'Das Bankkonto konnte nicht gespeichert werden. Bitte prüfen Sie die Angaben.',
    },
  },
  payout_onboarding: {
    title: 'Auszahlungskonto einrichten',
    description:
      'Ihre Umsatzbeteiligung wird monatlich auf ein Stripe-Auszahlungskonto ausgezahlt. Schließen Sie die Verifizierung einmalig ab — Auszahlungen bleiben bis dahin zurückgehalten.',
    missing: {
      title: 'Noch erforderlich, bevor Auszahlungen starten können:',
      bank_account: 'Hinterlegen Sie das Bankkonto, auf das Ihre Umsatzbeteiligung ausgezahlt werden soll.',
      business_details:
        'Vervollständigen Sie Ihre Unternehmensangaben, etwa Adresse, Steuernummer oder Registernummer.',
      people: 'Ergänzen Sie die Angaben zu Ihrem gesetzlichen Vertreter, Ihren Inhabern oder Geschäftsführern.',
      documents: 'Laden Sie die von Stripe angeforderten Verifizierungsdokumente hoch.',
      terms: 'Akzeptieren Sie die Nutzungsbedingungen von Stripe.',
      other: 'Ergänzen Sie die übrigen von Stripe angeforderten Angaben.',
    },
    start: 'Verifizierung starten',
    continue: 'Verifizierung fortsetzen',
    ready:
      'Auszahlungskonto verifiziert — Ihre Umsatzbeteiligung wird nach jedem Abrechnungszyklus automatisch ausgezahlt.',
  },
  payment_method: {
    title: 'Zahlungsmethode',
    empty: 'Keine Zahlungsmethode hinterlegt — die monatliche Rechnung kann noch nicht automatisch eingezogen werden.',
    add: 'Zahlungsmethode hinzufügen',
    replace: 'Ersetzen',
    remove: 'Entfernen',
    remove_confirm: {
      title: 'Diese Zahlungsmethode entfernen?',
      description:
        'Die Karte/das Mandat wird sofort von Stripe getrennt. Ohne Zahlungsmethode werden Rechnungen — auch bereits ausgestellte — über die Stripe-Rechnungsseite statt automatisch eingezogen.',
      confirm: 'Entfernen',
    },
  },
  invoices: {
    title: 'Rechnungen',
  },
};
